import type { ComponentType } from "react";
import { Container } from "../atoms/Container";
import { Eyebrow } from "../atoms/Eyebrow";
import { IOSDevice } from "../device/IOSDevice";
import { ScreenFinish } from "../screens/ScreenFinish";
import { ScreenTodayV2 } from "../screens/ScreenTodayV2";
import { ScreenWelcome } from "../screens/ScreenWelcome";

type SiteProofProps = {
  mobile?: boolean;
};

const FRAMES: Array<{ Screen: ComponentType; caption: string }> = [
  { Screen: ScreenWelcome, caption: "Day one." },
  { Screen: ScreenTodayV2, caption: "The longest run of your plan." },
  { Screen: ScreenFinish, caption: "The day after." },
];

export function SiteProof({ mobile = false }: SiteProofProps) {
  const pad = mobile ? 24 : 96;

  return (
    <section
      style={{
        paddingTop: mobile ? 72 : 128,
        paddingBottom: mobile ? 72 : 128,
        background: "var(--surface)",
      }}
    >
      <Container pad={pad}>
        <Eyebrow style={{ marginBottom: mobile ? 32 : 56 }}>A few screens from the app</Eyebrow>

        {mobile ? (
          <div style={{ position: "relative" }}>
            <div
              style={{
                display: "flex",
                gap: 24,
                overflowX: "auto",
                paddingBottom: 16,
                scrollSnapType: "x mandatory",
                margin: "0 -24px",
                padding: "0 24px 16px",
              }}
            >
              {FRAMES.map(({ Screen, caption }, i) => (
                <div
                  key={i}
                  style={{
                    flex: "0 0 auto",
                    scrollSnapAlign: "start",
                    display: "flex",
                    flexDirection: "column",
                    gap: 16,
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      transform: "scale(0.66)",
                      transformOrigin: "left top",
                      marginBottom: -298,
                      marginRight: -136,
                    }}
                  >
                    <IOSDevice width={402} height={874}>
                      <Screen />
                    </IOSDevice>
                  </div>
                  <div
                    style={{
                      fontFamily: "var(--display)",
                      fontStyle: "italic",
                      fontSize: 17,
                      color: "var(--text-2)",
                      width: 265,
                      textAlign: "center",
                    }}
                  >
                    {caption}
                  </div>
                </div>
              ))}
            </div>
            <div
              style={{
                fontFamily: "var(--ui)",
                fontSize: 11,
                color: "var(--text-3)",
                textAlign: "center",
                letterSpacing: "0.1em",
                textTransform: "uppercase",
                marginTop: 8,
              }}
            >
              ← swipe →
            </div>
          </div>
        ) : (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              gap: 48,
              alignItems: "start",
            }}
          >
            {FRAMES.map(({ Screen, caption }, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 28,
                }}
              >
                <div
                  style={{
                    transform: "scale(0.78)",
                    transformOrigin: "center top",
                    marginBottom: -190,
                  }}
                >
                  <IOSDevice width={402} height={874}>
                    <Screen />
                  </IOSDevice>
                </div>
                <div
                  style={{
                    fontFamily: "var(--display)",
                    fontStyle: "italic",
                    fontSize: 22,
                    color: "var(--text-2)",
                    textAlign: "center",
                    letterSpacing: "-0.01em",
                    lineHeight: 1.2,
                  }}
                >
                  {caption}
                </div>
              </div>
            ))}
          </div>
        )}
      </Container>
    </section>
  );
}
